import React, { useState } from 'react';
import styled from 'styled-components';
import { axiosClient } from "../api/proxy/AxiosClient";
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;

const Form = styled.div`
    background: white;
    padding: 50px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    width: 300px;
`;

const Title = styled.h2`
    color: #333;
    text-align: center;
    margin-bottom: 20px;
`;

const InputFieldWrapper = styled.div`
    position: relative;
    margin: 10px 0;
`;

const InputField = styled.input`
    width: 280px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;

    &:focus {
        border-color: #6e8fbd;
        outline: none;
    }
`;

const EyeButton = styled.button`
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    border: none;
    background: none;
    cursor: pointer;
    font-size: 18px;
    color: #6e8fbd;
`;

const SubmitButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #6e8fbd;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #5a7ca1;
    }
`;

const ErrorText = styled.p`
    color: red;
    text-align: center;
    font-size: 14px;
`;

const SuccessText = styled.p`
    color: green;
    text-align: center;
    font-size: 14px;
`;

const ChangePassword = () => {
      
    const navigate = useNavigate();

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [repeatNewPassword, setRepeatNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (newPassword !== repeatNewPassword) {
            setError('New passwords do not match.');
            return;
        }

        if (newPassword.length < 8) {
            setError('New password must be at least 8 characters.');
            return;
        }

        try {
            const response = await axiosClient.post(
                `/auth/change-password`,
                {
                    oldPassword,
                    newPassword,
                }
            );

            if (response.status === 201) {
                setSuccess('Password changed successfully.');
                setTimeout(() => navigate('/login'), 1500);
            }
        } catch (err) {
            console.error(err);
            setError(
                err.response?.data?.message || 'Failed to change password. Please try again.'
            );
        }
    };

    return (
        <Container>
            <Form>
                <Title>Change Password</Title>
                <form onSubmit={handleSubmit}>
                    <InputFieldWrapper>
                        <InputField
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Old password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            required
                        />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputField
                            type={showPassword ? 'text' : 'password'}
                            placeholder="New password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputField
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Repeat new password"
                            value={repeatNewPassword}
                            onChange={(e) => setRepeatNewPassword(e.target.value)}
                            required
                        />
                        <EyeButton
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? '🙈' : '👁️'}
                        </EyeButton>
                    </InputFieldWrapper>
                    <SubmitButton type="submit">Submit</SubmitButton>
                </form>
                {error && <ErrorText>{error}</ErrorText>}
                {success && <SuccessText>{success}</SuccessText>}
            </Form>
        </Container>
    );
};

export default ChangePassword;
